import { AbstractAdminApi } from './AbstractAdminApi'

class AdminApiV1 extends AbstractAdminApi {
  version: number = 1
}

export default new AdminApiV1()
